<div>
  <div class="container mx-auto">
    <!-- Section Header -->
    <div
      class="flex flex-wrap items-center justify-between mb-6 pb-4 border-b border-base-300"
    >
      <div class="flex-1">
        <h2
          class="text-2xl font-bold text-base-content flex items-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
            />
          </svg>
          Instructor Panel
        </h2>
        <p class="text-sm text-base-content/60 mt-1">
          Manage your live classes, recordings, and study materials
        </p>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="daisy-btn daisy-btn-outline gap-2"
          (click)="openInviteModal()"
        >
          <i class="fa-solid fa-user-plus"></i>
          <span class="hidden sm:inline">Invite Students</span>
        </button>
        @if (!this.selectedLiveClass) {
          <button
            class="daisy-btn daisy-btn-primary gap-2"
            routerLink="/live-classes/add"
          >
            <i class="fa-solid fa-plus"></i>
            <span class="hidden sm:inline">Create New Class</span>
          </button>
        }
      </div>
    </div>

    @if (this.selectedLiveClass) {
      <!-- Live Class Detail View -->
      <div class="bg-base-100 border border-base-300 rounded-2xl shadow-xl overflow-hidden">
        <!-- Header with breadcrumbs and back button -->
        <div
          class="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-8 text-white"
        >
          <div class="flex items-center justify-between mb-4">
            <div class="daisy-breadcrumbs text-blue-100">
              <ul>
                <li>
                  <a class="hover:text-white transition-colors">Instructor</a>
                </li>
                <li>
                  <a
                    (click)="deselectLiveClass()"
                    class="hover:text-white transition-colors cursor-pointer"
                    >Live Classes</a
                  >
                </li>
                <li class="text-white font-medium">
                  {{ selectedLiveClass.title }}
                </li>
              </ul>
            </div>
            <button
              (click)="deselectLiveClass()"
              class="daisy-btn daisy-btn-ghost text-white hover:bg-white hover:bg-opacity-20"
            >
              <i class="fa-solid fa-arrow-left mr-2"></i>
              <span class="hidden sm:inline">Back to Classes</span>
            </button>
          </div>
          <div>
            <div class="flex flex-wrap items-center gap-3 mb-2">
              <h2 class="text-3xl font-bold">
                {{ selectedLiveClass.title }}
              </h2>
              @if (selectedLiveClass.settings.isPublic === false) {
                <span
                  class="daisy-badge daisy-badge-neutral bg-black/30 text-white border-white/20 gap-1.5 font-medium shadow-sm backdrop-blur-sm"
                  title="Unlisted - Hidden from public catalog"
                >
                  <i class="fa-solid fa-eye-slash text-xs"></i>
                  <span>Unlisted</span>
                </span>
              }
            </div>
            <p class="text-blue-100 text-lg">
              Manage your sessions, recordings, and course materials
            </p>
          </div>
        </div>

        <!-- Tabs Content -->
        <div class="p-6">
          <black-ui-tabs [showDefaultTrigger]="true" class="w-full">
            <black-tabs-item name="schedule">
              <div *blackTabsContent class="py-6">
                <!-- Schedule Header -->
                <div class="mb-8">
                  <h3 class="text-2xl font-bold text-base-content mb-2">
                    <i
                      class="fa-regular fa-calendar-days text-primary mr-3"
                    ></i>
                    Schedule & Sessions
                  </h3>
                  <p class="text-base-content/70">
                    Manage your upcoming meetings and sessions
                  </p>
                </div>

                <!-- Meetings List -->
                <div class="space-y-4 mb-12">
                  @for (item of selectedLiveClass.meetings; track item) {
                    <div
                      class="bg-base-100 border border-base-300 rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300"
                    >
                      <div
                        class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
                      >
                        <div class="flex-1">
                          <div class="flex items-start gap-3 mb-3">
                            <div
                              class="w-3 h-3 bg-success rounded-full mt-2 flex-shrink-0"
                            ></div>
                            <div class="flex-1">
                              <h4
                                class="text-xl font-semibold text-base-content mb-2"
                              >
                                {{ item.name }}
                              </h4>
                              <div
                                class="flex flex-wrap items-center gap-4 text-sm text-base-content/70 mb-3"
                              >
                                <div class="flex items-center gap-2">
                                  <i
                                    class="fa-solid fa-calendar text-blue-500"
                                  ></i>
                                  <span class="font-medium">
                                    {{
                                      getMeetingInterval(
                                        item,
                                        selectedLiveClass.details.startDate,
                                        selectedLiveClass.details.endDate
                                      )
                                    }}
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <i
                                    class="fa-solid fa-clock text-purple-500"
                                  ></i>
                                  <span class="font-medium">
                                    {{
                                      getStartDate(
                                        item,
                                        selectedLiveClass.details.startDate,
                                        selectedLiveClass.details.endDate
                                      )[0] | date: 'shortTime'
                                    }}
                                    -
                                    {{
                                      getStartDate(
                                        item,
                                        selectedLiveClass.details.startDate,
                                        selectedLiveClass.details.endDate
                                      )[1] | date: 'shortTime'
                                    }}
                                  </span>
                                </div>
                              </div>
                              <p class="text-base-content/80 leading-relaxed">
                                {{
                                  getMeetingDescription(
                                    item,
                                    selectedLiveClass.details.startDate,
                                    selectedLiveClass.details.endDate
                                  )
                                }}
                              </p>
                              <div
                                class="flex flex-wrap items-center gap-2 mt-2"
                              >
                                @if (item.directJoinUrl) {
                                  <span
                                    class="daisy-badge daisy-badge-sm daisy-badge-primary daisy-badge-outline gap-1"
                                    title="{{ item.directJoinUrl }}"
                                  >
                                    <i class="fa-solid fa-link text-xs"></i>
                                    Direct Link
                                  </span>
                                } @else {
                                  <span
                                    class="daisy-badge daisy-badge-sm {{
                                      item.provider === 'ZOOM'
                                        ? 'daisy-badge-info'
                                        : 'daisy-badge-secondary'
                                    }}"
                                  >
                                    {{ item.provider ?? 'REALTIMEKIT' }}
                                  </span>
                                }
                                @if (isMeetingConfigured(item)) {
                                  <span
                                    class="daisy-badge daisy-badge-sm daisy-badge-success gap-1"
                                  >
                                    <i
                                      class="fa-solid fa-circle-check text-xs"
                                    ></i>
                                    Ready
                                  </span>
                                } @else {
                                  <span
                                    class="daisy-badge daisy-badge-sm daisy-badge-warning gap-1"
                                  >
                                    <i
                                      class="fa-solid fa-triangle-exclamation text-xs"
                                    ></i>
                                    Setup Needed
                                  </span>
                                }
                              </div>

                              <!-- Direct Link inline editor -->
                              @if (isEditingDirectLink(item.shareLinkId)) {
                                <div
                                  class="mt-3 p-3 bg-base-200 rounded-lg max-w-lg space-y-2"
                                >
                                  <label
                                    class="text-xs font-semibold text-base-content"
                                    >Direct Meeting Link (Zoom, Meet, Teams,
                                    etc.)</label
                                  >
                                  <div class="flex flex-wrap gap-2">
                                    <input
                                      type="url"
                                      [ngModel]="
                                        getDirectLinkInput(item.shareLinkId)
                                      "
                                      (ngModelChange)="
                                        setDirectLinkInput(
                                          item.shareLinkId,
                                          $event
                                        )
                                      "
                                      placeholder="https://meet.google.com/abc-defg-hij"
                                      class="daisy-input daisy-input-bordered daisy-input-sm flex-1 min-w-[200px] text-xs"
                                    />
                                    <button
                                      type="button"
                                      (click)="saveDirectLink(item)"
                                      class="daisy-btn daisy-btn-sm daisy-btn-primary"
                                    >
                                      Save
                                    </button>
                                    @if (item.directJoinUrl) {
                                      <button
                                        type="button"
                                        (click)="removeDirectLink(item)"
                                        class="daisy-btn daisy-btn-sm daisy-btn-error daisy-btn-outline"
                                        title="Remove Direct Link"
                                      >
                                        Clear
                                      </button>
                                    }
                                    <button
                                      type="button"
                                      (click)="
                                        cancelEditDirectLink(item.shareLinkId)
                                      "
                                      class="daisy-btn daisy-btn-sm daisy-btn-ghost"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              } @else if (item.directJoinUrl) {
                                <div
                                  class="flex items-center gap-2 mt-2 text-xs text-base-content/70"
                                >
                                  <i class="fa-solid fa-link text-primary"></i>
                                  <span class="truncate max-w-sm font-mono">{{
                                    item.directJoinUrl
                                  }}</span>
                                  <button
                                    type="button"
                                    (click)="startEditDirectLink(item)"
                                    class="daisy-btn daisy-btn-ghost daisy-btn-xs"
                                    title="Edit Direct Link"
                                  >
                                    <i class="fa-solid fa-pen-to-square"></i>
                                  </button>
                                  <button
                                    type="button"
                                    (click)="removeDirectLink(item)"
                                    class="daisy-btn daisy-btn-ghost daisy-btn-xs text-error hover:bg-error hover:bg-opacity-10"
                                    title="Remove Direct Link"
                                  >
                                    <i class="fa-solid fa-trash-alt"></i>
                                  </button>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        <div
                          class="flex-shrink-0 flex flex-col sm:flex-row items-end sm:items-center gap-2"
                        >
                          @if (item.shareLinkId) {
                            @if (isMeetingConfigured(item)) {
                              <button
                                (click)="joinMeeting(item)"
                                class="daisy-btn daisy-btn-primary gap-2 shadow-lg hover:shadow-xl transition-all duration-300 min-w-[140px]"
                                [disabled]="isMeetingLoading(item.shareLinkId)"
                              >
                                @if (isMeetingLoading(item.shareLinkId)) {
                                  <span
                                    class="daisy-loading daisy-loading-spinner daisy-loading-sm"
                                  ></span>
                                  <span>Starting...</span>
                                } @else {
                                  <i class="fa-solid fa-video"></i>
                                  <span>Start Meeting</span>
                                }
                              </button>
                            } @else {
                              <div class="flex flex-wrap gap-2 items-center">
                                @if (item.provider === 'ZOOM') {
                                  <button
                                    (click)="generateZoomForMeeting(item)"
                                    [disabled]="
                                      isGeneratingZoom(item.shareLinkId)
                                    "
                                    class="daisy-btn daisy-btn-info daisy-btn-sm gap-1 shadow"
                                    title="Generate Zoom Meeting"
                                  >
                                    @if (isGeneratingZoom(item.shareLinkId)) {
                                      <span
                                        class="daisy-loading daisy-loading-spinner daisy-loading-xs"
                                      ></span>
                                    } @else {
                                      <i class="fa-solid fa-video"></i>
                                    }
                                    <span>Generate Zoom</span>
                                  </button>
                                }
                                @if (
                                  item.provider === 'REALTIMEKIT' ||
                                  item.provider === 'DYTE'
                                ) {
                                  <button
                                    (click)="generateRtkForMeeting(item)"
                                    [disabled]="
                                      isGeneratingRtk(item.shareLinkId)
                                    "
                                    class="daisy-btn daisy-btn-secondary daisy-btn-sm gap-1 shadow"
                                    title="Generate RealtimeKit Meeting"
                                  >
                                    @if (isGeneratingRtk(item.shareLinkId)) {
                                      <span
                                        class="daisy-loading daisy-loading-spinner daisy-loading-xs"
                                      ></span>
                                    } @else {
                                      <i
                                        class="fa-solid fa-tower-broadcast"
                                      ></i>
                                    }
                                    <span>Generate RTK</span>
                                  </button>
                                }
                                @if (!isEditingDirectLink(item.shareLinkId)) {
                                  <button
                                    (click)="startEditDirectLink(item)"
                                    class="daisy-btn daisy-btn-outline daisy-btn-sm gap-1"
                                  >
                                    <i class="fa-solid fa-link"></i>
                                    <span>Add Direct Link</span>
                                  </button>
                                }
                                <button
                                  class="daisy-btn daisy-btn-disabled daisy-btn-sm gap-1"
                                  disabled
                                  title="Meeting is not yet configured"
                                >
                                  <i class="fa-solid fa-ban"></i>
                                  <span>Start Unavailable</span>
                                </button>
                              </div>
                            }
                          } @else {
                            <div class="daisy-badge daisy-badge-outline">
                              No Meeting Link
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>

                <!-- Calendar Section -->
                <div
                  class="bg-base-100 rounded-xl border border-base-300 p-6 shadow-lg"
                >
                  <div class="mb-6">
                    <h3 class="text-2xl font-bold text-base-content mb-2">
                      <i
                        class="fa-solid fa-calendar-alt text-primary mr-3"
                      ></i>
                      Class Calendar
                    </h3>
                    <p class="text-base-content/70">
                      Visual overview of your scheduled sessions
                    </p>
                  </div>
                  @if (this.currentCalendarEvents) {
                    <black-event-calendar
                      [events]="this.currentCalendarEvents"
                      class="w-full"
                    ></black-event-calendar>
                  } @else {
                    <div class="text-center py-12 text-base-content/60">
                      <i
                        class="fa-regular fa-calendar text-4xl mb-4 opacity-50"
                      ></i>
                      <p>No calendar events available</p>
                    </div>
                  }
                </div>
              </div>
            </black-tabs-item>
            >
            <black-tabs-item name="recordings">
              <div *blackTabsContent class="py-6">
                <div class="mb-8">
                  <h3 class="text-2xl font-bold text-base-content mb-2">
                    <i class="fa-solid fa-video text-primary mr-3"></i>
                    Session Recordings
                  </h3>
                  <p class="text-base-content/70">
                    Access and manage your recorded sessions
                  </p>
                </div>
                <div>
                  <black-recordings
                    [selectedLiveClass]="selectedLiveClass"
                    [isInstructorView]="true"
                  ></black-recordings>
                </div>
              </div>
            </black-tabs-item>
            <black-tabs-item name="study_materials">
              <div *blackTabsContent class="py-6">
                <div class="mb-8">
                  <h3 class="text-2xl font-bold text-base-content mb-2">
                    <i class="fa-solid fa-book text-primary mr-3"></i>
                    Study Materials
                  </h3>
                  <p class="text-base-content/70">
                    Manage course resources and materials
                  </p>
                </div>
                <div>
                  <black-study-materials
                    [editModeEnabled]="true"
                    [selectedLiveClassId]="selectedLiveClass.id ?? null"
                    [selectedLiveClass]="selectedLiveClass"
                  ></black-study-materials>
                </div>
              </div>
            </black-tabs-item>
            <black-tabs-item name="quizzes">
              <div *blackTabsContent class="py-6">
                <black-instructor-quizzes
                  [editModeEnabled]="true"
                  [selectedLiveClassId]="selectedLiveClass.id ?? null"
                  [selectedLiveClass]="selectedLiveClass"
                ></black-instructor-quizzes>
              </div>
            </black-tabs-item>
            <black-tabs-item name="announcements">
              <div *blackTabsContent class="py-6">
                <div class="mb-8">
                  <h3 class="text-2xl font-bold text-base-content mb-2">
                    <i class="fa-solid fa-bullhorn text-primary mr-3"></i>
                    Announcements & Push Notifications
                  </h3>
                  <p class="text-base-content/70">
                    Send updates, reminders, and alerts directly to your enrolled students
                  </p>
                </div>
                <div>
                  <black-class-announcements
                    [liveClassId]="selectedLiveClass.id"
                    [isInstructor]="true"
                  ></black-class-announcements>
                </div>
              </div>
            </black-tabs-item>
          </black-ui-tabs>
        </div>
      </div>
    } @else {
      <!-- Live Classes List View -->
      <div class="space-y-8">
        <!-- Classes Grid -->
        <div class="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          @for (item of liveClassItems; track item) {
            <div
              class="bg-base-100 border border-base-300 rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 flex flex-col h-full"
            >
              <!-- Class Banner -->
              <div
                class="relative h-48 overflow-hidden bg-gradient-to-br from-blue-600 to-purple-600 shrink-0"
              >
                <img
                  [src]="
                    getResourceImagePath(item.settings.bannerImageResource)
                  "
                  class="w-full h-full object-cover opacity-90"
                  alt="Class banner"
                />
                <div class="absolute top-4 right-4 flex items-center gap-1.5">
                  @if (item.settings.isPublic === false) {
                    <span
                      class="daisy-badge daisy-badge-sm daisy-badge-neutral bg-neutral/80 text-neutral-content backdrop-blur-sm gap-1 font-medium shadow-sm"
                      title="Unlisted - Hidden from public catalog"
                    >
                      <i class="fa-solid fa-eye-slash text-[10px]"></i>
                      <span>Unlisted</span>
                    </span>
                  }
                  <span
                    class="daisy-badge daisy-badge-sm font-medium shadow-sm"
                    [ngClass]="{
                      'daisy-badge-warning':
                        item.status === 'UNDER_REVIEW',
                      'daisy-badge-success': item.status === 'PUBLISHED',
                      'daisy-badge-info': item.status === 'DRAFT',
                      'daisy-badge-ghost': item.status === 'ARCHIVED',
                    }"
                  >
                    {{ item.status }}
                  </span>
                </div>
              </div>

              <!-- Class Content -->
              <div class="p-6 flex-1 flex flex-col justify-between gap-4">
                <div>
                  <h3 class="text-xl font-bold text-base-content mb-2 line-clamp-2">
                    {{ item.title }}
                  </h3>
                  <p class="text-base-content/70 text-sm">
                    Manage sessions, recordings, and materials
                  </p>
                </div>

                <!-- Action Buttons -->
                <div class="flex gap-3 mt-auto">
                  <button
                    (click)="navigateToLiveClass(item.id)"
                    class="flex-1 daisy-btn daisy-btn-primary gap-2 shadow-md hover:shadow-lg transition-all"
                  >
                    <i class="fa-regular fa-calendar-days"></i>
                    <span class="hidden sm:inline">Schedule</span>
                  </button>
                  <button
                    class="flex-1 daisy-btn daisy-btn-outline gap-2 shadow-md hover:shadow-lg transition-all"
                    (click)="editLiveClass(item.id)"
                  >
                    <i class="fa-solid fa-cog"></i>
                    <span class="hidden sm:inline">Manage</span>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Empty State -->
        @if (liveClassItems.length === 0) {
          <div class="text-center py-16">
            <div class="mb-8">
              <div
                class="w-24 h-24 bg-base-200 rounded-full flex items-center justify-center mx-auto mb-4"
              >
                <i
                  class="fa-solid fa-chalkboard-user text-4xl text-base-content/40"
                ></i>
              </div>
              <h3 class="text-2xl font-bold text-base-content mb-2">
                No Live Classes Yet
              </h3>
              <p class="text-base-content/70 max-w-md mx-auto">
                Get started by creating your first live class. You'll be able to
                schedule sessions, manage recordings, and share study materials.
              </p>
            </div>
            <button
              class="daisy-btn daisy-btn-primary daisy-btn-lg gap-2 shadow-lg hover:shadow-xl transition-shadow"
              routerLink="/live-classes/add"
            >
              <i class="fa-solid fa-plus"></i>
              Create Your First Class
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Student Invitation Modal -->
<black-invite-student-modal
  [isOpen]="showInviteModal"
  [availableLiveClasses]="liveClassItems"
  [defaultLiveClassId]="inviteTargetLiveClassId"
  (invited)="onInviteSuccess()"
  (close)="showInviteModal = false"
></black-invite-student-modal>
